import { DEFAULT_PARTNER_LOGO } from "../assets/images";

export default function PartnerSlider({ partners = [] }) {
  const hasPartners = partners.length > 0;

  return (
    <section className="partner-slider">
      <h2 className="text-center">Nos partenaires</h2>

      <div className="partner-track d-flex justify-content-center">
        {hasPartners ? (
          partners.map((partner) => (
            <a
              key={partner._id}
              href={partner.link}
              target="_blank"
              rel="noopener noreferrer"
              className="partner-card"
            >
              <img
                src={partner.image || DEFAULT_PARTNER_LOGO}
                alt={partner.logo}
              />
            </a>
          ))
        ) : (
          <div className="partner-card partner-card--empty">
            <img src={DEFAULT_PARTNER_LOGO} alt="Partenaires à venir" />
          </div>
        )}
      </div>
    </section>
  );
}